import { __awaiter, __generator } from 'tslib';

var loaded = false;
function init(_a) {
    var id = _a.id, trackScriptUrl = _a.trackScriptUrl, onClose = _a.onClose;
    return __awaiter(this, void 0, void 0, function () {
        var _this = this;
        return __generator(this, function (_b) {
            if (loaded) {
                console.warn('LiveAgent already initialised');
                return [2 /*return*/];
            }
            return [2 /*return*/, new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        try {
                            /**
                             * NOTE: the following function is copied from: https://support.liveagent.com/551283-Advanced-button-integration#element
                             * d: the document of the page
                             * src: the url of the liveagent script
                             * c: callback to invoke when the script is loaded
                             * in our case, we resolve the promise so that the caller knows the script is loaded,
                             * and we provide an object with the following methods:
                             * - createButton: creates a LiveAgent button instance with the given chatId (depends on language)
                             * - openChat: open the chat modal
                             *
                             * Implementation for reference: https://bitbucket.org/gaminginnovationgroup/lazy-live-agent/src/master/src/lazyLiveAgent.js
                             */
                            (function (d, src, c) {
                                var t = d.scripts[d.scripts.length - 1], s = d.createElement('script');
                                s.id = id;
                                s.async = true;
                                s.src = src;
                                s.onload = s.onreadystatechange = function () {
                                    var rs = this.readyState;
                                    if (rs && rs != 'complete' && rs != 'loaded') {
                                        return;
                                    }
                                    c(this);
                                };
                                t.parentElement.insertBefore(s, t.nextSibling);
                            })(document, trackScriptUrl, function (e) {
                                loaded = true;
                                LiveAgent.disableOnlineVisitorsTracking();
                                var popupInterval;
                                var chatButton;
                                resolve({
                                    addUserDetails: function (userDetails) {
                                        if (userDetails) {
                                            LiveAgent.addContactField('UserID', userDetails.userId);
                                            LiveAgent.setUserDetails(userDetails.email, userDetails.firstName, userDetails.lastName);
                                        }
                                        else {
                                            LiveAgent.clearAllUserDetails();
                                        }
                                    },
                                    createButton: function (chatId) {
                                        if (chatButton) {
                                            return;
                                        }
                                        chatButton = LiveAgent.createButton(chatId, e);
                                        overwriteOnClose(chatButton);
                                        return waitButtonInitialization();
                                    },
                                    openChat: function () {
                                        if (!chatButton || !chatButton.isInitialized()) {
                                            console.warn('LiveAgent button not initialized yet');
                                            return;
                                        }
                                        chatButton.onClick();
                                        if (getPopup()) {
                                            onPopupClose(function () {
                                                LiveAgent.instance.setOpenedWidget(undefined);
                                                chatButton.onCloseFunction_();
                                            });
                                        }
                                    },
                                });
                                function overwriteOnClose(chatButton) {
                                    if (onClose) {
                                        chatButton.oldOnCloseFunction_ =
                                            chatButton.onCloseFunction_;
                                        chatButton.onCloseFunction_ = function () {
                                            chatButton.oldOnCloseFunction_();
                                            onClose();
                                        };
                                    }
                                }
                                function waitButtonInitialization() {
                                    return __awaiter(this, void 0, void 0, function () {
                                        var maxTimeout, intervalTimeout, currentTimeout;
                                        return __generator(this, function (_a) {
                                            maxTimeout = 5000;
                                            intervalTimeout = 100;
                                            currentTimeout = 0;
                                            return [2 /*return*/, new Promise(function (resolve, reject) {
                                                    var interval = setInterval(function () {
                                                        currentTimeout += intervalTimeout;
                                                        if (chatButton.isInitialized()) {
                                                            clearInterval(interval);
                                                            resolve();
                                                        }
                                                        else if (currentTimeout >= maxTimeout) {
                                                            clearInterval(interval);
                                                            reject("Live agent button not initialized after " + maxTimeout / 1000 + " seconds");
                                                        }
                                                    }, intervalTimeout);
                                                })];
                                        });
                                    });
                                }
                                function onPopupClose(callback) {
                                    clearInterval(popupInterval);
                                    popupInterval = setInterval(function () {
                                        if (getPopup().closed) {
                                            clearInterval(popupInterval);
                                            callback();
                                        }
                                    }, 1000);
                                }
                                function getPopup() {
                                    var _a;
                                    return (_a = LiveAgent.instance.openedWidget) === null || _a === void 0 ? void 0 : _a.popupWindow;
                                }
                            });
                        }
                        catch (e) {
                            reject(e);
                        }
                        return [2 /*return*/];
                    });
                }); })];
        });
    });
}

export { init };
